<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
defineProps<{
  modelValue: string,
  placeholder?: string | undefined,
}>()

defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
</script>

<template>
  <input
    :value="modelValue"
    @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    type="search"
    :placeholder="placeholder || $t('Search')"
    v-bind="$attrs"
  />
</template>